import { DatePicker } from "@mui/lab";
import {
  AlertColor,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React, { useImperativeHandle, useMemo } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Quotation, QuotationItem } from "./QuotationAccessories";
import { DropDownComboOption } from "../../component/GenericFilter";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import { GeneralDialog } from "../../component/GeneralDialog";
import Title from "../../component/Title";
import { CustomDropDown2 } from "../../component/CustomDropDown2";
import { GetCustLangIdsByLanguageId, Languages } from "../../../common/Constants";
import moment from "moment";
import { CommonProps } from "../../component/MainContents";
import { CustomDropDown1 } from "../../component/CustomDropDown1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridCellParams, GridColumns, GridPreProcessEditCellProps, GridRenderCellParams, GridRowId, GridToolbarContainer, GridValueSetterParams } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Add, Delete, Search } from "@mui/icons-material";
import { FormatNumber, Pad } from "../../../common/Formatter";
import { ProductList, ProductListHandle } from "../products/ProductList";
import { ProductListItem } from "../products/ProductAccessories";
import { Customer } from "../customers/CustomerAccessories";
import { AwayFromZeroRounding, HasDuplicates, ValidateNumber } from "../../../common/CommonFunctions";
import { QuotationViewer, QuotationViewerHandle } from "./QuotationViewer";
import { BranchInfo } from "../branches/BranchAccessories";
import { renewToken } from "../../../services/AuthService";
import { NumberTypes } from "../../../models/enums/NumberType";
import { OpenMode } from "../../../common/Enums";
import { EndUserCombo, EndUserListItem } from "../end-users/EndUserAccessories";
import { EndUserList, EndUserListHandle } from "../end-users/EndUserList";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

export interface QuotationSingleHandle {
  Initialise: (mode: OpenMode, quotation: Quotation) => void;
}

export function GetQuotationRegion(quotationNo: string) {
  return quotationNo.substring(4, 6);
}

export const QuotationSingle = React.forwardRef(
  (props: CommonProps, ref: React.Ref<QuotationSingleHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const singleModalRef = React.useRef<ProductListHandle>(null);
    const viewerModalRef = React.useRef<QuotationViewerHandle>(null);
    const endUserListModalRef = React.useRef<EndUserListHandle>(null);

    const [open, setOpen] = React.useState(false);
    const [openMode, setOpenMode] = React.useState<OpenMode>(OpenMode.NEW);
    const [model, setModel] = React.useState<Quotation>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [region, setRegion] = React.useState<string>("");
    const [filteredCustomers, setFilteredCustomers] = React.useState<DropDownComboOption[]>([]);
    
    const [disableRegionDropDown, setDisableRegionDropDown] = React.useState<boolean>(true);
    const [disablePreviewButton, setDisablePreviewButton] = React.useState<boolean>(true);

    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

    const [selectedEndUser, setSelectedEndUser] = React.useState<string>("");
    const [selectedEndUserId, setSelectedEndUserId] = React.useState<number>(0);

    const [gridData, setGridData] = React.useState<QuotationItem[]>([]);

    const columnWidth25 = useMemo(() => GetColumnWidth(25, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth35 = useMemo(() => GetColumnWidth(35, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth40 = useMemo(() => GetColumnWidth(40, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth50 = useMemo(() => GetColumnWidth(50, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth55 = useMemo(() => GetColumnWidth(55, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth60 = useMemo(() => GetColumnWidth(60, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth68 = useMemo(() => GetColumnWidth(68, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth70 = useMemo(() => GetColumnWidth(70, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth80 = useMemo(() => GetColumnWidth(80, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth100 = useMemo(() => GetColumnWidth(100, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth120 = useMemo(() => GetColumnWidth(120, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth140 = useMemo(() => GetColumnWidth(140, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    function GetColumnWidth(width: number, isTiny: boolean, isSmall: boolean) {
      switch (width) {
        case 25:
          return isTiny ? 25 : (isSmall ? 30 : 35);
        case 35:
          return isTiny ? 35 : (isSmall ? 40 : 45);
        case 40:
          return isTiny ? 40 : (isSmall ? 45 : 55);
        case 50:
          return isTiny ? 50 : (isSmall ? 58 : 68);
        case 55:
          return isTiny ? 55 : (isSmall ? 70 : 80);
        case 60:
          return isTiny ? 60 : (isSmall ? 80 : 90);
        case 68:
          return isTiny ? 68 : (isSmall ? 85 : 100);
        case 70:
          return isTiny ? 70 : (isSmall ? 90 : 105);
        case 80:
          return isTiny ? 80 : (isSmall ? 100 : 110);
        case 100:
          return isTiny ? 100 : (isSmall ? 125 : 150);
        case 120:
          return isTiny ? 120 : (isSmall ? 155 : 190);
        case 140:
          return isTiny ? 140 : (isSmall ? 180 : 220);
        default:
          return width;
      }
    }

    //Grid columns
    const columns: GridColumns = [
      {
        field: 'seq', headerName: 'No.', disableColumnMenu: true, 
        width: columnWidth40, minWidth: columnWidth40,
        type: 'number', editable: true, align: 'right',
        valueSetter: (param: GridValueSetterParams) => onSeqChanged(param),
        preProcessEditCellProps: validateSeqChanged,
        cellClassName: style.NumberTextField
      },
      { 
        field: 'model', headerName: '型式', 
        width: columnWidth140, minWidth: columnWidth140,
        type: 'string' 
      },
      { 
        field: 'productCode', headerName: '商品CD', 
        width: columnWidth120, minWidth: columnWidth120, type: 'string' 
      },
      {
        field: 'orderQty', headerName: '数量', disableColumnMenu: true, sortable: false, 
        width: columnWidth50, minWidth: columnWidth50,
        type: 'number', editable: true,
        valueSetter: onOrderQtyChanged,
        preProcessEditCellProps: validateQtyChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'percentage', headerName: '折扣%', disableColumnMenu: true, sortable: false, 
        width: columnWidth70, minWidth: columnWidth70,
        type: 'number', editable: true,
        valueFormatter: (param) => FormatNumber(param.value, 5),
        valueSetter: onPercentageChanged,
        cellClassName: (param: GridCellParams) => {
          let row: QuotationItem = param.row;
          let percent = parseFloat(param.value.toString().replace(/,/g, ''));
          if (percent < row.minQuotationPercent)
          {
            return style.NumberTextFieldRed;
          } 
          else
          {
            return style.NumberTextField;
          }
        }
      },
      { 
        field: 'minPOPercent', headerName: '仕切比率', disableColumnMenu: true, sortable: false, 
        width: columnWidth70, minWidth: columnWidth70,
        type: 'number', valueFormatter: (param) => FormatNumber(param.value, 1) 
      },
      {
        field: 'euPrice', headerName: 'EU Price', disableColumnMenu: true, sortable: false, 
        width: columnWidth70, minWidth: columnWidth70,
        type: 'number', editable: true,
        valueFormatter: (param) => FormatNumber(param.value, 2),
        valueSetter: onEuPriceChanged,
        cellClassName: (param: GridCellParams) => {
          let row: QuotationItem = param.row;
          let euPrice = parseFloat(param.value.toString().replace(/,/g, ''));
          let exRate = model?.exRate ?? 1;
          if (row.price && row.price > 0 && euPrice / row.price * 100 / exRate + 0.001  < row.minQuotationPercent)
          {
            return style.NumberTextFieldRed;
          } 
          else
          {
            return style.NumberTextField;
          }
        }
      },
      {
        field: 'discountCode', headerName: '特值號', disableColumnMenu: true, sortable: false, 
        flex: 3, type: 'string', editable: true, 
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "discountCode", 25),
      },
      {
        field: 'productDesc', headerName: '製品名', flex: 8, type: 'string', minWidth: 100, editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "productDesc", 80),
      },
      { field: 'description', headerName: '針長', flex: 3, type: 'string' },
      { field: 'price', headerName: '標準価格', width: columnWidth100, minWidth: columnWidth100, type: 'number' },
      { field: 'unit', headerName: '单位', disableColumnMenu: true, sortable: false, width: columnWidth40, minWidth: columnWidth40, type: 'string' },
      { field: 'minOrderQty', headerName: '最少数', disableColumnMenu: true, sortable: false, width: columnWidth50, minWidth: columnWidth50, type: 'number' }
    ];

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 10,
    });

    const selectedData = React.useRef<QuotationItem[]>([]);

    //Dialogs and snacks
    const hasChanges = React.useRef<boolean>(false);
    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }

    function CustomToolbar() {
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => AddRow()}>Add</Button>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Delete />} onClick={() => DeleteRows()}>Del</Button>
        </GridToolbarContainer>
      );
    }

    function onCellValueChanged(param: GridValueSetterParams, field: string, maxLength: number) {
      renewToken();
      let row: QuotationItem = param.row;
      let cellValue: string = param.value;
      if (maxLength>0)
        cellValue = cellValue.slice(0, maxLength);

      Object.entries(row).forEach(([key, value]) => {
        if (`${key}` === field)
          Reflect.set(row, key, cellValue);
      });

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      Object.entries(tmpData[index]).forEach(([key, value]) => {
        if (`${key}` === `${field}`)
          Reflect.set(tmpData[index], key, cellValue);
      });
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onSeqChanged(param: GridValueSetterParams) {
      let row: QuotationItem = param.row;
      let tempGridData = [...gridData];  
      let index = tempGridData.findIndex(x => x.id === row.id);
      let duplicatedRowIndex = tempGridData.findIndex(x => x.seq == param.value);
      if (duplicatedRowIndex > -1)
      {
        //swap sequence no.
        tempGridData[duplicatedRowIndex].seq = tempGridData[index].seq;
      }

      tempGridData[index].seq = param.value;
      setGridData(tempGridData);

      hasChanges.current = true;
      return { ...param.row, row };
    }
        
    function validateSeqChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }
    
    function validateQtyChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function onOrderQtyChanged(param: GridValueSetterParams) {
      let row: QuotationItem = param.row;
      let orderQty = parseInt(param.value.toString().replace(/,/g, ''));

      if (row.minOrderQty)
      {
        if ((orderQty % row.minOrderQty ?? 1) != 0)
          row.orderQty = Math.ceil(orderQty / row.minOrderQty ?? 1) * (row.minOrderQty ?? 1)
        else
          row.orderQty = orderQty;
      }
      else 
        row.orderQty = orderQty;

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].orderQty = row.orderQty;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onPercentageChanged(param: GridValueSetterParams) {
      let row: QuotationItem = param.row;
      row.percentage = parseFloat(param.value.toString().replace(/,/g, ''));
      let exRate = model?.exRate ?? 1;
      row.euPrice = AwayFromZeroRounding(parseFloat((row.price ?? 0).toFixed(2)) * row.percentage / 100 * exRate, 2);

      if (row.percentage < param.row.minPOPercent)
      {
        showSnackBar("Percentage is smaller than minimum PO percent!", "", "error");
      }

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].percentage = row.percentage;
      tmpData[index].euPrice = row.euPrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onEuPriceChanged(param: GridValueSetterParams) {
      let row: QuotationItem = param.row;
      row.euPrice = parseFloat(param.value.toString().replace(/,/g, ''));
      let exRate = model?.exRate ?? 1;
      if (row.price && row.price > 0)
        row.percentage = AwayFromZeroRounding(row.euPrice / row.price * 100 / exRate, 5);

      if (row.price && row.price > 0 && (row.euPrice / row.price * 100 / exRate)  < row.minQuotationPercent)
      {
        showSnackBar("Percentage is smaller than minimum quotation percent!", "", "error");
      }

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      tmpData[index].percentage = row.percentage;
      tmpData[index].euPrice = row.euPrice;
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function AddRow() {
      singleModalRef.current?.Initialise();
    }

    function DeleteRows() {
      if (selectedData.current.length == 0)
      {
        return;
      }
      let tempGridData = [...gridData];
      selectedData.current.forEach(item => {
        let index = tempGridData.findIndex(x => x.lotNo === item.lotNo);
        if (index > -1) {
          tempGridData.splice(index, 1);
        }
      });
      let i = 1;
      tempGridData.forEach(x => {
        x.id = i;
        x.lotNo = i;
        i++
      })
      setGridData(tempGridData);
      let temp = model;
      if (temp) {
        temp.quotationItems = tempGridData;
      }
      setModel(temp);
      setSelectionModel([])
      selectedData.current = [];
    }

    useImperativeHandle(ref, () => ({
      Initialise(mode: OpenMode, quotation: Quotation) {
        setOpen(true);
        renewToken();

        hasChanges.current = false;
        setOpenMode(mode);

        FilterCustomersByLanguage([0]); //Always show customer names of any language
        if (mode === OpenMode.NEW)
        {
          setRegion(GetQuotationRegion(quotation.quotationNo));
          setDisableRegionDropDown(false);
          setDisablePreviewButton(true);
        }
        else if (mode === OpenMode.EDIT)
        {
          setRegion(GetQuotationRegion(quotation.quotationNo));
          setDisableRegionDropDown(true);
          setDisablePreviewButton(false);
  
          quotation.quotationItems.forEach(i => {
            i.id = i.lotNo;
          });
        } 
        else if (mode === OpenMode.COPY)
        {
          setRegion(GetQuotationRegion(quotation.quotationNo));
          setDisableRegionDropDown(false);
          setDisablePreviewButton(true);
  
          quotation.quotationItems.forEach(i => {
            i.id = i.lotNo;
          });
        }

        let temp: any = { ...model };
        temp = quotation;
        if (props.paymentTerms.findIndex(x => x.name === temp.paymentTerm) > -1)
          temp.paymentTerm = temp.paymentTerm;
        else
          temp.paymentTerm = "30 days after delivery";
        temp.mobile = "";  
        temp.email = "";
        temp.loginName = "";

        setModel(temp);

        setSelectedEndUser(temp.endUser);
        setSelectedEndUserId(temp.endUserID);

        setGridData(quotation.quotationItems)
    },
    }));

    function closeModal() {
      setDialogOpen(false);
      setOpen(false);
      props.onClose(false, model!);
    }

    function closeModalCheck(keepOpen: boolean) {
      if (hasChanges.current) {
        setDialogOpen(true);
      } else {
        setDialogOpen(false);
        setOpen(keepOpen);
        props.onClose(false, model!);
      }
    }

    function isSaveValid(showWarning: boolean) {
      let proceed = true;
      let warning = "";
      let noOfLines = 0;
      if (model) {
        let lotNos = model.quotationItems.map(item => item.lotNo);
        if (HasDuplicates(lotNos)) {
          warning += "Duplicated \'No\' found in quotation items\r\n";
          noOfLines++;
          proceed = false;
        }

        if (model.customerName === "" || model.customerID === 0) {
          warning += "Please select a customer\r\n"
          noOfLines++;
          proceed = false
        }

        if (model.staff === "" || model.staffID === 0) {
          warning += "Please select a staff\r\n"
          noOfLines++;
          proceed = false
        }

        if (!proceed && showWarning) {
          showSnackBar(warning.toString(), "", "error");
        }
      }

      return proceed;
    }

    function Update(
      propertyName: string,
      propertyValue: any,
      validationRegex?: RegExp
    ) {
      let proceed = true;

      if (validationRegex !== undefined) {
        proceed = validationRegex.test(propertyValue);
      }

      if (proceed) {
        let temp: any = { ...model };
        
        if (temp[propertyName] != propertyValue)
        {
          hasChanges.current = true;
          temp[propertyName] = propertyValue ?? null;
          setModel(temp);
        }     
      }
    }

    function CustomerChanged(newCustomer: any) {
      if (newCustomer) {
        let custId = newCustomer.value % 100000;
        axios.get<Customer>('Api/V1/Customer/' + custId.toString(), {
          headers: {
            'Content-Encoding': 'gzip'
          }
        })
          .then((result) => {
            hasChanges.current = true;
            let temp: any = { ...model };
            temp.customerID = custId;
            temp.customerName = newCustomer.name;
            temp.custLangID = Math.trunc(newCustomer.value / 100000);
            temp.attention = result.data.contactPerson;
            temp.phone = result.data.phone1;
            temp.fax = result.data.fax1;
            if (props.paymentTerms.findIndex(x => x.name === result.data.paymentTerm) > -1)
              temp.paymentTerm = result.data.paymentTerm;
            else
              temp.paymentTerm = "30 days after delivery";

            setModel(temp);            
          },
            (error) => {
              console.log(error);
            }
          )
          .catch((error) => {
            console.log(error);
          });        
      }
    }

    function LanguageChanged(langId: number) {
      hasChanges.current = true;
      let custLangIds = GetCustLangIdsByLanguageId(langId);
      let temp: any = { ...model };
      let availableCustomerLanguageIds: number[] = [];

      for (var i = 1; i <= 3; i++) {
        let index = props.customers.findIndex(s => s.value === ((temp.customerID ?? 1) + i * 100000).toString());
        if (index > 0)
        {
          availableCustomerLanguageIds.push(i);
        }
      }

      let commonLangIds: number[] = custLangIds.filter(function(id) {
        return availableCustomerLanguageIds.indexOf(id) > -1;
      });

      if (commonLangIds.length == 0)
      {
        commonLangIds = availableCustomerLanguageIds;
      }

      let originalId = commonLangIds.find(x => x == model?.custLangID) ?? commonLangIds[0];
      temp.custLangID = originalId;
      temp.languageID = langId;
      switch(langId)
      {
        case 1:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = x.nameEng ?? "";
          });
          break;
        case 2:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = x.nameJpn ?? "";
          });
          break;
        case 3:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = x.nameChi ?? "";
          });
          break;
        case 4:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameChi ?? "")).slice(0,80);
          });
          break;
        case 5:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = ((x.nameEng ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;
        case 6:
          temp.quotationItems.forEach((x: QuotationItem) => {
            x.productDesc = ((x.nameChi ?? "") + "  " + (x.nameJpn ?? "")).slice(0,80);
          });
          break;
      }
      setModel(temp);

      FilterCustomersByLanguage([0])
    }

    function FilterCustomersByLanguage(langIds: number[]) {
      let temp: DropDownComboOption[] = props.customers;
      let result: DropDownComboOption[] = [];
      if (langIds.findIndex( x => x === 0) > -1)
      {
        setFilteredCustomers(props.customers);
      } 
      else
      {
        langIds.forEach((id) => {
          result = result.concat(Object.values(temp).filter(c => Math.trunc(parseInt(c.value) / 100000) === id));
        });
        setFilteredCustomers(result);
      }
    }

    function RegionChanged(region: string) {
      hasChanges.current = true;

      axios.get<any[]>(`Api/V1/Branch`, {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          let branchSelected: BranchInfo | undefined = result.data.find(b => b.region === region);
          if (branchSelected)
          {
            let temp: any = { ...model };
            let newQuotationNo: string = "QT" + branchSelected.japanYear + branchSelected.region + Pad(branchSelected.quotationNo, 5);
            temp["quotationNo"] = newQuotationNo;
            setModel(temp);
          }
        },
          (error) => {
            console.log(error);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    }

    function RevisionNoChanged(revisionNo: string) {
      hasChanges.current = true;
      let temp: any = { ...model };
      temp["revisionNo"] = revisionNo.slice(0,1);
      setModel(temp);
    }

    function CurrencyChanged(ccy: string) {
      hasChanges.current = true;
      let temp: any = { ...model };
      let exRate = props.currencies.find(c => c.name === ccy)?.value;
      temp["currency"] = ccy;
      temp["exRate"] = Number(exRate);
      setModel(temp);
    }

    function ExRateChanged(exrate: string) {
      hasChanges.current = true;
      
      let msg = ValidateNumber(exrate, NumberTypes.FLOAT, true);
      if (msg === "")
      {
        let temp: any = { ...model };
        temp["exRate"] = exrate;
        
        temp.quotationItems.forEach((x: QuotationItem) => {
          if ((x.price ?? 0) > 0)
            x.euPrice = AwayFromZeroRounding(parseFloat(exrate) * (x.price ?? 0) * x.percentage /100, x.dp);
        });
        setModel(temp);
        setGridData([...temp.quotationItems]);
      }
    }

    function SaveChanges(
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      close: boolean
    ) {
      if (isSaveValid(true)) {
        event.preventDefault();
        event.stopPropagation();

        let m = model;
        if (m)
        {
          m.quotationItems = gridData;
          m.createDate = moment(m.createDate).format();
          let maxSeq = Math.max(...m.quotationItems.map(item => {return item.seq ?? 1;}));
          let i = 1;
          m.quotationItems.forEach(item => {
            item.lotNo = item.seq ?? maxSeq + i;
            i++;
          });
          setModel(m);
        }
  
        if (openMode === OpenMode.EDIT)
        {
          axios.put<Quotation>('Api/V1/Quotation/', m).then(
            (result) => {
              props.onClose(true, result.data);

              if (result.data.quotationItems?.length > 0)
              {
                result.data.quotationItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.quotationItems)
              }              
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = "";  
              temp.email = "";
              temp.loginName = "";
              setModel(temp);
  
              showSnackBar("Quotation saved successfully.", "", "success");
              hasChanges.current = false;
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        } 
        else
        {
          axios.post<Quotation>('Api/V1/Quotation/', m).then(
            (result) => {
              props.onClose(true, result.data);
  
              if (result.data.quotationItems?.length > 0)
              {
                result.data.quotationItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.quotationItems)
              }
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = "";  
              temp.email = "";
              temp.loginName = "";
              setModel(temp);
  
              showSnackBar("Quotation created successfully.", "", "success");
              hasChanges.current = false;
              setDisablePreviewButton(false);
              setOpenMode(OpenMode.EDIT);
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        }
      }
    }

    function Preview(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      let m = model;
      if (m)
        viewerModalRef.current?.Initialise(m.quotationNo);
    }

    function PopulateSelectedEndUser(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>) {
      if (!hasSelection)
        return;

      let m = model;
      if (m) {
        m.endUser = endUserListItem.current.endUserName;
        m.endUserID = endUserListItem.current.endUserId;
        setModel(m);
      }
      setSelectedEndUser(endUserListItem.current.endUserName);
      setSelectedEndUserId(endUserListItem.current.endUserId);
    }

    function PopulateSelectedProducts(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>)
    {
      if (!hasSelection)
        return;

      let newQoutationItems: QuotationItem[] = [];
      let m = model;
      if (m) {
        let lotNos: number[] | undefined = m?.quotationItems?.map(i => i.lotNo);

        let maxLotNo: number = 1;
        if (lotNos && lotNos.length>0)
        {
          maxLotNo = Math.max(...lotNos) + 1;
        }

        productItems.current.forEach((item) => {
          let minPercent = item.minQuotationPercent > 70 ? item.minQuotationPercent : 70;
          let calculatedPrice = (item.price ?? 0) * (minPercent / 100) * (m?.exRate ?? 0);
          let productDescription: string = "";
          switch (m?.languageID ?? 1) {
            case 1:
              productDescription = item.nameEng ?? (item.nameChi ?? (item.nameJpn ?? ""));
              break;
            case 2:
              productDescription = item.nameJpn ?? (item.nameChi ?? (item.nameEng ?? ""));
              break;
            case 3:
              productDescription = item.nameChi ?? (item.nameJpn ?? (item.nameEng ?? ""));
              break;
            case 4:
              productDescription = (item.nameEng ?? "") + " " + (item.nameChi ?? "");
              break;
            case 5:
              productDescription = (item.nameEng ?? "") + " " + (item.nameJpn ?? "");
              break;
          }

          const quotationItem: QuotationItem = {
            id: maxLotNo,
            quotationNo: m?.quotationNo ?? "",
            lotNo: maxLotNo,
            productID: item.productID,
            orderQty: item.minOrderQty ?? 1,
            percentage: minPercent,
            euPrice: calculatedPrice,
            productDesc: productDescription,
            discountCode: "",
            seq: maxLotNo,
            nameJpn: item.nameJpn,
            nameChi: item.nameChi,
            nameEng: item.nameEng,
            description: item.description,
            productCode: item.productCode,
            model: item.model,
            price: item.price,
            unit: item.unit,
            minOrderQty: item.minOrderQty,
            endUser: item.endUser,
            dp: 2,
            minQuotationPercent: item.minQuotationPercent,
            minPOPercent: item.minPOPercent
          };
          newQoutationItems.push(quotationItem);
          maxLotNo++;
        }
        )

        let tempData = [...gridData, ...newQoutationItems];
        setGridData(tempData);

        m.quotationItems = tempData;
        setModel(m);
        hasChanges.current = true;
      }

    }

    return (
      <div>
        <Modal open={open} onClose={() => closeModalCheck(true)}>
          <div className={style.ModalMain}>
            {model && !loading ? (
              <div className={style.ModalBody}>
                <Title pageTitle="Quotation" />
                <div className={style.ModalContent}>
                  <div className={style.ModalFields}>
                    <CustomDropDown2 className={style.ModalContentField} 
                      dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                      firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                      firstTextBoxMinWidth={tinyScreen ? "110px" : (smallScreen ? "190px" : "295px")}
                      dropDownBoxId="region-dropdown" dropDownBoxLabel="Region" dropDownBoxDisabled={disableRegionDropDown} 
                      firstTextBoxLabel="Quotation No" firstTextBoxName="txtQuotationNo" secondTextBoxName="txtRevisionNo"
                      dropDownBoxValue={region} dropDownBoxOptions={props.regions}
                      firstTextBoxValue={model.quotationNo}
                      secondTextBoxValue={model.revisionNo}
                      onSelectionChanged={RegionChanged}
                      onTextBoxValueChanged={RevisionNoChanged}
                      secondTextBoxVisibility={openMode !== OpenMode.NEW} />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <div className={style.ModalInnerContentFieldOneThirdWidthLeft}
                        style={{ minWidth: tinyScreen ? "110px" : (smallScreen ? "140px" : "170px") }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            key="quotationDate"
                            label="Quotation Date"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={Date.parse(model.createDate)}
                            onChange={(newValue) => Update("createDate", moment(newValue).format('YYYY/MM/DD'))}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} size="small" />}
                          />
                        </LocalizationProvider>
                      </div>
                      <Autocomplete className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        limitTags={2}
                        onChange={(e, selected) => {
                          let temp: any = { ...model };
                          temp.staffID = Number(selected?.value);
                          temp.staff = selected?.name;
                          setModel(temp);
                        }}
                        options={props.sales}
                        getOptionLabel={(option: DropDownComboOption) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.name}
                            </li>
                          );
                        }}
                        value={props.sales.find(s => s.value === model.staffID?.toString()) || null}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={"Sales"}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    </div>
                    <Autocomplete className={style.ModalContentField}
                      limitTags={2}
                      onChange={(e, selected) => CustomerChanged(selected)}
                      options={filteredCustomers}
                      getOptionLabel={(option: DropDownComboOption) => option.name}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.value}>
                            {option.name}
                          </li>
                        );
                      }}
                      value={filteredCustomers.find(s => s.value === (model.customerID + model.custLangID * 100000).toString()) || null}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label={"Customer"}
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                    <TextField className={style.ModalContentField}
                      value={model.attention}
                      label="Attention"
                      inputProps={{ maxLength: 30 }}
                      onChange={(e) => Update("attention", e.target.value)}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "342px" : "462px") }}
                      size="small"
                      fullWidth
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField} 
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldOneThirdWidthLeft}
                          value={model.languageID}
                          onChange={(e) => LanguageChanged(parseInt(e.target.value))}
                          style={{ minWidth: tinyScreen ? "80px" : (smallScreen ? "110px" : "140px") }}
                          select
                          label="Language"
                          size="small"
                          fullWidth
                        >
                          {Languages.map((item) => (
                            <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
                          ))}
                      </TextField>
                      <TextField className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        id="payment-term"
                        value={model.paymentTerm}
                        onChange={(e) => Update("paymentTerm", e.target.value)}
                        select
                        label="Payment Term"
                        size="small"
                        fullWidth                      
                      >
                        {props.paymentTerms.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>
                    <TextField className={style.ModalContentField}
                      id="delivery-term"
                      style={{ minWidth: tinyScreen ? "248px" : (smallScreen ? "344px" : "464px") }}
                      value={model.deliveryTerm}
                      onChange={(e) => Update("deliveryTerm", e.target.value)}
                      select
                      label="Delivery Method"
                      size="small"
                      fullWidth
                    >
                      {props.deliveryMethods.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField className={style.ModalContentField}
                      id="end-user"                    
                      style={{ minWidth: tinyScreen ? "248px" : (smallScreen ? "344px" : "464px") }}
                      value={selectedEndUser}
                      onChange={(e) => endUserListModalRef.current?.Initialise() }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton size="small"
                              onClick={() => { endUserListModalRef.current?.Initialise(); }
                              }
                            >
                              <Search />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      label="End User"
                      size="small"
                      fullWidth
                    />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.phone}
                        label="Telephone"
                        onChange={(e) => Update("phone", e.target.value)}
                        size="small"
                        fullWidth                      
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={model.fax}
                        label="Fax"
                        onChange={(e) => Update("fax", e.target.value)}
                        size="small"
                        fullWidth                      
                        />
                    </div>
                  </div>
                  <div className={style.ModalFields}>
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.shipDate}
                        label="Ship Date"
                        inputProps={{ maxLength: 50 }}
                        onChange={(e) => Update("shipDate", e.target.value)}
                        size="small"
                        fullWidth     
                      />
                      <CustomDropDown1 className={style.ModalInnerContentFieldRight}
                        dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                        firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                        firstTextBoxMinWidth={tinyScreen ? "60px" : (smallScreen ? "75px" : "90px")}
                        dropDownBoxId="currency-dropdown" dropDownBoxLabel="CCY" dropDownBoxDisabled={disableRegionDropDown} firstTextBoxLabel="Ex. Rate" firstTextBoxName="txtExRate"
                        dropDownBoxValue={model.currency} dropDownBoxOptions={props.currencies}
                        firstTextBoxValue={model.exRate.toString()} firstTextBoxReadOnly={false}
                        type="number"
                        onSelectionChanged={CurrencyChanged}
                        onTextBoxValueChanged={ExRateChanged} />
                    </div>
                    <TextField className={style.ModalContentField}
                      value={model.remark1}
                      label="Remark 1"
                      onChange={(e) => Update("remark1", e.target.value)}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                      fullWidth     
                    />
                    <TextField className={style.ModalContentField}
                      value={model.remark2}
                      label="Remark 2"
                      onChange={(e) => Update("remark2", e.target.value)}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                      fullWidth     
                    />
                    <TextField className={style.ModalContentField}
                      value={model.remark3}
                      label="Remark 3"
                      onChange={(e) => Update("remark3", e.target.value)}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                      fullWidth     
                    />
                  </div>
                  <div className={style.PageContent} style={{ minHeight: "280px" }}>
                    <DataGridPro
                      getRowId={(row) => row.id}
                      rows={gridData}
                      columns={columns}
                      pageSize={searchData.pageSize}
                      onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                      pagination
                      rowsPerPageOptions={[10, 20, 40]}
                      loading={loading}
                      checkboxSelection
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomTablePagination
                      }}
                      componentsProps={{
                        footer: { rowsPerPageOptions: [10, 20, 40] }
                      }}
                      selectionModel = {selectionModel}
                      onSelectionModelChange={(selections) => {
                        setSelectionModel(selections)
                        const ids = new Set(selections);
                        const selectedRows = gridData.filter((row) => ids.has(row.lotNo));
                        selectedData.current = selectedRows;
                      }}
                      disableSelectionOnClick={true}
                      headerHeight={tinyScreen ? 28 : (smallScreen ? 32 : 36)}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                    />
                  </div>
                </div>

                <div className={style.ModalFooter}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    onClick={(e) => SaveChanges(e, false)}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    disabled = {disablePreviewButton}
                    onClick={(e) => Preview(e)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="contained"
                    className={style.margin}
                    onClick={(e) => closeModalCheck(false)}
                  >
                    Close
                  </Button>
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </Modal>

        <SnackBarMessage {...snackSettings} />

        <GeneralDialog
          title={"Save Changes?"}
          message={
            "Changes have been made, did you want to save before closing?"
          }
          open={dialogOpen}
          options={[
            {
              text: "Save",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => SaveChanges(event, true),
              color: "secondary",
              variant: "contained",
            },
            {
              text: "No",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => closeModal(),
              color: "primary",
              variant: "contained",
            },
          ]}
        />

        <ProductList
          ref={singleModalRef}
          onClose={(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) => PopulateSelectedProducts(hasSelection, productItems)}
        />

        <EndUserList
          ref={endUserListModalRef}
          onClose={(hasSelection: boolean, endUserListItem: React.MutableRefObject<EndUserListItem>) => PopulateSelectedEndUser(hasSelection, endUserListItem)}
          customers={props.customers}
          regions={props.regions} />


        <QuotationViewer ref={viewerModalRef} onClose={()=>{}}/>
      </div>
    );


  }

);
